import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { OtherUseInZendraInconsistencyPlanningOrchestratorService, OtherUseInZendraInconsistencyDto, OtherUsesInZendraInconsistenciesExcelDownloadDto } from 'orchestrator';
import { OtherUseInconsistencyBase } from '../other-use-inconsistency/other-use-inconsistency-base';
import { OTHERUSEINCONSISTENCYONLYINZENDRA_CONFIG, OTHERUSEINCONSISTENCYONLYINZENDRA_FIELDS } from './other-use-inconsistency-only-in-zendra.config';
@Component({
  selector: 'app-other-use-inconsistency-only-in-zendra',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class OtherUseInconsistencyOnlyInZendra extends OtherUseInconsistencyBase<OtherUseInZendraInconsistencyDto, OtherUsesInZendraInconsistenciesExcelDownloadDto> {
  protected readonly queryService = inject(OtherUseInZendraInconsistencyPlanningOrchestratorService);
  config = OTHERUSEINCONSISTENCYONLYINZENDRA_CONFIG;
  fields = OTHERUSEINCONSISTENCYONLYINZENDRA_FIELDS;
  protected getEntityName(): string { return 'OtherUseInconsistencyOnlyInZendra'; }
}
